var zeroPad = function(value, digits) {
  return Math.pow(10, Math.max(0, digits - value.toString().length))
    .toString().substr(1) + value;
}

var getCentury = function (value) {
  var shortYear = parseInt(value);
  return shortYear < 50 ? 2000 + shortYear : 1900 + shortYear;
}

var getMonthByName = value => [
    'january','february','march','april','may','june','july','august',
    'september','october','november','december', 'jan','feb','mar','apr','may','jun','jul','aug','sep','oct','nov','dec'
  ].indexOf(value) % 12 + 1

var getComparator = value => {
  switch (value) {
    case 'before':
    case '<':
      return -1
    case '>':
    case 'after':
      return 1
    default:
      return value
  }
}

var format = function (type, value) {
  switch (type) {
    case 'comparator':
      return getComparator(value.toString())
    case 'month_name':
      return getMonthByName(value.toString())
    case 'year':
    case 'month':
    case 'date':
    case 'hour':
    case 'minute':
    case 'second':
      return parseInt(value);
    case 'year_short':
      return getCentury(value)
    default:
      return value;
  }
}
var formatType = typeName => {
  switch (typeName) {
    case 'month_name':
      return 'month'
    case 'year_short':
      return 'year'
    default:
      return typeName;
  }
}
var formatByType = function (type, value) {
  return function (value) {
    return {
      type: formatType(type),
      value: format(type, value)
    }
  }
}

var nil = () => null

var join = function(data) {
  return data.map(d=>d ? d.value ? d.value : d : d)
}

var merge = data => {
  var i = 0
  return data.reduce(
    (dateObjs, token) => {
      if (Array.isArray(token)) {
        Object.assign(dateObjs[i], merge(token)[0])
      } else if (token && token.type === 'range') {
        i = 1
        dateObjs[i] = dateObjs[i] || {}
      } else if (token) {
        dateObjs[i][token.type] = token.value;
      }
      return dateObjs;
    }, [{}]
)
}
var mergeDate = function(data) {
  var i = 0
  return data.reduce(function(dateObjs, token) {
      if (Array.isArray(token)) {
        Object.assign(dateObjs[i], mergeDate(token)[0])
      } else if (token && token.type === 'range') {
        i = 1
        let {year, month, date} = dateObjs[0]
        dateObjs[i] = { year, month, date }
      } else if (token) {
        dateObjs[i][token.type] = token.value;
      }
      return dateObjs;
    }, [{}]
)
}

var log = function(data) {
  console.log(data);
  return data;
}

module.exports = { zeroPad, format, formatByType, merge, mergeDate,  join, log, nil }


// WEBPACK FOOTER //
// ./project/services/date-parser/date-utils.js